<script setup lang="ts"></script>

<template>
  <div
    class="flex items-center p-sm hover:bg-surface-tertiary active:bg-surface-tertiary rounded-sm gap-sm transition duration-300"
  >
    <slot></slot>
  </div>
</template>
